import { useEffect, useState } from "react";
import { useLang } from "@/i18n";
import api from "@/api";
import PageSections from "@/components/PageSections";

const CONTENT = {
  mr: {
    history_title: "आमचा इतिहास",
    history: [
      "समता पार्टीची स्थापना १९९४ मध्ये भारताचे माजी संरक्षण व रेल्वे मंत्री स्व. श्री. जॉर्ज फर्नांडिस आणि श्री. नितीश कुमार यांनी जनता दळातून वेगळे होऊन केली. पक्षाने पहिल्यांदाच नितीश कुमार यांना २००० मध्ये बिहारचे मुख्यमंत्री केले.",
      "समता पार्टी कधीही JD(U) मध्ये विलीन झाला नाही आणि स्वतंत्र राजकीय पक्ष म्हणून कार्यरत राहिला. पक्षाला २३/११/१९९४ रोजी राष्ट्रीय पक्षाचा दर्जा मिळाला होता. सध्या पक्षाचे राष्ट्रीय अध्यक्ष श्री. उदय मंडल आहेत.",
      "२ राज्य सरकारे, २० खासदार, ७२ आमदार आणि NDA सोबत युती (१९९६-२००३) — हा आमचा गौरवशाली प्रवास आहे.",
      "महाराष्ट्र राज्याचे प्रदेश अध्यक्ष श्री. त्रुणेश देवलेकर संपूर्ण महाराष्ट्र राज्याचे अत्यंत उत्कृष्ट नेतृत्व करत आहेत. श्रीमती. रजनी देवलेकर प्रदेश अध्यक्ष (महिला विंग) — महाराष्ट्रातील महिला विंगचे यशस्वी नेतृत्व करत आहेत.",
    ],
    mh_title: "महाराष्ट्र प्रदेश",
    mh: "समता पार्टी महाराष्ट्र प्रदेश इकाई कल्याण पश्चिम येथील कार्यालयातून राज्यभरात संघटना विस्तारित करत आहे. सामाजिक न्याय, समानता आणि सर्वसामान्यांच्या हक्कांसाठी आम्ही कटिबद्ध आहोत. राज्य, जिल्हा, तालुका, शहर आणि ग्रामपंचायत — या पाचही स्तरांवर आमची संघटना उभारली जात आहे.",
    ideology_title: "आमची विचारधारा",
    ideology: [
      "समता — प्रत्येक नागरिकाला समान हक्क आणि समान संधी",
      "सामाजिक न्याय — दलित, आदिवासी, ओबीसी आणि अल्पसंख्याक समाजाचे कल्याण",
      "श्रमिक हक्क — कामगार, शेतकरी आणि असंघटित क्षेत्रातील कामगारांचे संरक्षण",
      "पारदर्शक प्रशासन — भ्रष्टाचारमुक्त आणि जबाबदार शासन",
    ],
  },
  hi: {
    history_title: "हमारा इतिहास",
    history: [
      "समता पार्टी की स्थापना 1994 में भारत के पूर्व रक्षा एवं रेल मंत्री स्व. श्री जॉर्ज फर्नांडिस और श्री नीतीश कुमार ने जनता दल से अलग होकर की। पार्टी ने पहली बार नीतीश कुमार को 2000 में बिहार का मुख्यमंत्री बनाया।",
      "समता पार्टी कभी JD(U) में विलीन नहीं हुई और एक स्वतंत्र राजनीतिक दल के रूप में कार्यरत रही। पार्टी को 23/11/1994 को राष्ट्रीय पार्टी का दर्जा मिला था। वर्तमान में पार्टी के राष्ट्रीय अध्यक्ष श्री उदय मंडल हैं।",
      "2 राज्य सरकारें, 20 सांसद, 72 विधायक और NDA के साथ गठबंधन (1996-2003) — यह हमारी गौरवशाली यात्रा है।",
      "महाराष्ट्र राज्य के प्रदेश अध्यक्ष श्री त्रुणेश देवलेकर पूरे महाराष्ट्र राज्य का अत्यंत बेहतरीन नेतृत्व कर रहे हैं। श्रीमती रजनी देवलेकर प्रदेश अध्यक्ष (महिला विंग) — महाराष्ट्र की महिला विंग का सफल नेतृत्व कर रही हैं।",
    ],
    mh_title: "महाराष्ट्र प्रदेश",
    mh: "समता पार्टी महाराष्ट्र प्रदेश इकाई कल्याण पश्चिम स्थित कार्यालय से पूरे राज्य में संगठन का विस्तार कर रही है। सामाजिक न्याय, समानता और आम आदमी के अधिकारों के लिए हम प्रतिबद्ध हैं। राज्य, जिला, तालुका, शहर और ग्राम पंचायत — इन पाँचों स्तरों पर हमारा संगठन खड़ा किया जा रहा है।",
    ideology_title: "हमारी विचारधारा",
    ideology: [
      "समता — हर नागरिक को समान अधिकार और समान अवसर",
      "सामाजिक न्याय — दलित, आदिवासी, ओबीसी और अल्पसंख्यक समाज का कल्याण",
      "श्रमिक अधिकार — मज़दूरों, किसानों और असंगठित क्षेत्र के श्रमिकों की रक्षा",
      "पारदर्शी प्रशासन — भ्रष्टाचार मुक्त और जवाबदेह शासन",
    ],
  },
  en: {
    history_title: "Our History",
    history: [
      "The Samata Party was founded in 1994 by former Defence & Railway Minister of India, Late Shri George Fernandes, and Shri Nitish Kumar, after breaking away from the Janata Dal. The party first made Nitish Kumar the Chief Minister of Bihar in 2000.",
      "The Samata Party was never merged into JD(U) and continued to function as an independent political party. It was recognised as a National Party on 23/11/1994. The party is currently led by National President Shri Uday Mandal.",
      "2 State Governments, 20 MPs, 72 MLAs and an alliance with the N.D.A. (1996-2003) — this is our glorious journey.",
      "Shri Trunesh Deolekar, State President of Maharashtra, leads the entire state with great dedication. Smt. Rajni Deolekar, State President (Ladies Wing), successfully leads the Ladies Wing across Maharashtra.",
    ],
    mh_title: "Maharashtra Pradesh",
    mh: "The Samata Party Maharashtra State Unit is expanding its organisation across the state from its office at Kalyan West. We are committed to social justice, equality and the rights of the common citizen. Our organisation is being built at all five levels — State, District, Taluka, City and Gram Panchayat.",
    ideology_title: "Our Ideology",
    ideology: [
      "Samata (Equality) — equal rights and equal opportunities for every citizen",
      "Social Justice — welfare of Dalit, Adivasi, OBC and minority communities",
      "Labour Rights — protection of workers, farmers and the unorganised sector",
      "Transparent Governance — corruption-free and accountable administration",
    ],
  },
};

export default function About() {
  const { t, lang } = useLang();
  const [serverBlocks, setServerBlocks] = useState(null);
  useEffect(() => {
    api.get("/pages/about").then((r) => setServerBlocks(r.data.content?.[lang] || null)).catch(() => {});
  }, [lang]);
  const c = CONTENT[lang];
  const fallback = [
    { title: c.history_title, body: c.history.join("\n\n") },
    { title: c.mh_title, body: c.mh },
    { title: c.ideology_title, body: c.ideology.map((i) => "- " + i).join("\n") },
  ];
  const blocks = serverBlocks || fallback;

  return (
    <div data-testid="about-page">
      <section className="bg-emerald-950 text-white py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold" data-testid="about-heading">{t.about_title}</h1>
          <p className="text-amber-400 mt-2 italic">"{t.tagline}"</p>
        </div>
      </section>

      <PageSections blocks={blocks} testPrefix="about" />

      <section className="max-w-4xl mx-auto px-4 sm:px-6 pb-14">
        <div className="bg-emerald-50 rounded-2xl p-8 border border-emerald-100">
          <img src="/george-fernandes.jpeg" alt="George Fernandes" className="w-28 h-28 rounded-full object-cover border-4 border-amber-500 mx-auto" />
          <h3 className="font-heading font-bold text-emerald-950 text-center mt-4">Late Shri George Fernandes</h3>
          <p className="text-xs text-slate-500 text-center">{t.founder} — Samata Party (1994)</p>
        </div>
      </section>
    </div>
  );
}
